import React from 'react';

const MaintenanceScreen = ({ config }) => {
  return (
    <div className="min-h-screen bg-toon-yellow flex flex-col items-center justify-center p-4">
      <div className="text-center max-w-2xl mx-auto">
        {config?.logo_url && (
          <img 
            src={config.logo_url} 
            alt="Toon House Logo" 
            className="h-40 mx-auto mb-8"
          />
        )}
        
        <h1 className="text-4xl font-bold mb-6">Under Maintenance</h1>
        <p className="text-xl mb-8">
          We're currently performing some updates to make your experience better.
          Please check back soon!
        </p>
        
        {config?.global_footer_text && (
          <div className="mt-12 text-sm text-gray-600">
            {config.global_footer_text}
          </div>
        )}
      </div>
    </div>
  );
};

export default MaintenanceScreen;
